import { render, staticRenderFns } from "./ListArea.vue?vue&type=template&id=055dbdd0&"
import script from "./ListArea.vue?vue&type=script&lang=js&"
export * from "./ListArea.vue?vue&type=script&lang=js&"
import style0 from "./ListArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports